module.exports = __webpack_public_path__ + "static/media/date.a1e56c6d.svg";